var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBulbOverlay({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 100 101",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M49.194 11.29c1.781 0 3.225-1.516 3.225-3.387V3.387C52.42 1.517 50.975 0 49.194 0c-1.782 0-3.226 1.516-3.226 3.387v4.516c0 1.87 1.444 3.387 3.226 3.387zm47.419 29.839h-4.516c-1.87 0-3.387 1.444-3.387 3.226 0 1.781 1.516 3.226 3.387 3.226h4.516c1.87 0 3.387-1.445 3.387-3.226 0-1.782-1.516-3.226-3.387-3.226zM11.29 44.355c0-1.782-1.516-3.226-3.387-3.226H3.387C1.517 41.129 0 42.573 0 44.355c0 1.781 1.516 3.226 3.387 3.226h4.516c1.87 0 3.387-1.445 3.387-3.226zM79.923 22.58a3.31 3.31 0 002.342-.973l3.136-3.12a3.325 3.325 0 00-.081-4.611 3.308 3.308 0 00-4.602-.082l-3.136 3.12a3.325 3.325 0 00.501 5.106c.544.365 1.185.559 1.84.56zm-59.045-5.63l-3.163-3.148a3.335 3.335 0 00-4.64.082 3.354 3.354 0 00-.082 4.65l3.163 3.148a3.335 3.335 0 004.64-.082 3.354 3.354 0 00.082-4.65zm65.385 52.497a3.335 3.335 0 00-4.64.082 3.354 3.354 0 00-.081 4.65l3.162 3.148a3.335 3.335 0 004.64-.082 3.354 3.354 0 00.082-4.65l-3.163-3.148zm-74.946 0l-3.162 3.148a3.354 3.354 0 00.082 4.65 3.335 3.335 0 004.64.082l3.162-3.147a3.354 3.354 0 00-.082-4.65 3.335 3.335 0 00-4.64-.083z",
    clipRule: "evenodd"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulbOverlay);
export default __webpack_public_path__ + "static/media/bulbOverlay.1e9914a1.svg";
export { ForwardRef as ReactComponent };